import React, { createContext, useContext, useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import CustomCloseButton from "./CustomCloseButton.jsx";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

const Notification = ({ children }) => {
  const theme = useSelector(state => state.settings.theme);

  const notify = useCallback((type, message) => {
    switch (type) {
      case "success":
        toast.success(message, {
          className: `hover:opacity-90 bg-notificationSuccess text-notificationText w-[500px]`,
          autoClose: 4000,
        });
        break;
      case "error":
        toast.error(message, {
          className: `hover:opacity-90 bg-notificationError text-notificationText w-[500px]`,
          autoClose: 5000,
        });
        break;
      case "warn":
        toast.warn(message, {
          className: `hover:opacity-90 bg-notificationWarn text-notificationText w-[500px]`,
          autoClose: 5000,
        });
        break;
      default:
        toast(message, {
          className: `hover:opacity-90 bg-notificationSuccess text-notificationText w-[500px]`,
          autoClose: 5000,
        });
    }
  }, []);

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <ToastContainer
        icon={false}
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={theme}
        closeButton={<CustomCloseButton />}
      />
    </NotificationContext.Provider>
  );
};

export default Notification;
